import styled from 'styled-components'

export const Center = styled.div`
  display: flex;
  flex-direction: ${({ column }) => (column ? 'column' : 'row')};
  align-items: ${({ ai }) => (ai ? ai : 'center')};
  justify-content: ${({ jc }) => (jc ? jc : 'center')};
  gap: ${({ gap }) => (gap ? `${gap}px` : '10px')};
  margin-bottom: ${({ mb }) => (mb ? `${mb}px` : undefined)};
`
